import React, { useEffect } from "react";
import classNames from "classnames";

import Styles from "./Button.module.scss";
import { useTheme } from "../../styles/useTheme";
import { SkeletonContainer } from "../Skeleton/Skeleton";

type Props = {
  id?: string;
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  submit?: boolean;
  basic?: boolean;
  secondary?: boolean;
  customColor?: boolean;
  fullWidth?: boolean;
  className?: string;
  disabled?: boolean;
  style?: Record<string, unknown>;
  tabIndex?: number;
  skeleton?: {
    show?: boolean;
    className?: string;
    style?: React.CSSProperties;
  };
};

const Button = ({
  id,
  children,
  onClick,
  submit,
  basic,
  secondary,
  customColor,
  fullWidth,
  className,
  disabled,
  style,
  tabIndex,
  skeleton,
}: Props) => {
  const { primaryButton, secondaryButton } = useTheme();
  // Sentry Debug
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sentryDebug = urlParams.get("sentryDebug");

    if (sentryDebug === "true") {
      let test: Record<string, unknown>;
      // eslint-disable-next-line
      // @ts-ignore
      console.log(test.test);
    }
  }, []);

  return (
    <SkeletonContainer show={skeleton?.show} style={{ ...skeleton?.style }}>
      <button
        id={id}
        type={submit ? "submit" : "button"}
        className={classNames(Styles.button, className, {
          [primaryButton]: !customColor && !secondary && !basic && !disabled,
          [secondaryButton]: secondary,
          [Styles.basic]: basic,
          [Styles.fullWidth]: fullWidth,
          [Styles.disabled]: disabled,
        })}
        onClick={onClick}
        disabled={disabled}
        style={style}
        tabIndex={tabIndex}
      >
        {children}
      </button>
    </SkeletonContainer>
  );
};

export default Button;
